import { useMemo } from 'react'
import { FormikProps } from 'formik'
import { IPackInput } from '../../types/pack'
import { isEditionPublished } from '../../services/packForm'
import { useTrackingChanges } from '../PackForm/hooks'

export const usePublishedEditionChanged = ({
  values,
  initialValues,
}: FormikProps<IPackInput>): boolean => {
  const { editions = [] } = values
  const { editions: initEditions = [] } = initialValues

  return useMemo(() => {
    const snapOfChangedPublishedInitEditions = JSON.stringify(
      initEditions.filter(isEditionPublished)
    )
    const snapOfChangedPublishedEditions = JSON.stringify(
      editions.filter(isEditionPublished)
    )
    return snapOfChangedPublishedInitEditions !== snapOfChangedPublishedEditions
  }, [editions, initEditions])
}

export const usePublishedPackChanged = ({
  values,
  initialValues,
}: FormikProps<IPackInput>): boolean =>
  useTrackingChanges(values, initialValues, [
    'title',
    'language',
    'slugline',
    'description',
    'topicCodes',
    'tags',
    'location',
    'byline',
    'contacts',
    'previewImages',
  ])
